/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateOrganizationProfileMutationRequest,
  UpdateOrganizationProfileMutationResponse,
  UpdateOrganizationProfilePathParams,
} from "../types/UpdateOrganizationProfile.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateOrganizationProfileMutationKey = () =>
  [{ url: "/v1/organization/:organizationId/profile" }] as const

export type UpdateOrganizationProfileMutationKey = ReturnType<
  typeof updateOrganizationProfileMutationKey
>

/**
 * @description Supplier portal users only. Updates name, address, registration IDs, and business type for the caller's organization.
 * @summary Update organization profile
 * {@link /v1/organization/:organizationId/profile}
 */
export async function updateOrganizationProfile(
  organizationId: UpdateOrganizationProfilePathParams["organizationId"],
  data: UpdateOrganizationProfileMutationRequest,
  config: Partial<RequestConfig<UpdateOrganizationProfileMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateOrganizationProfileMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateOrganizationProfileMutationRequest
  >({
    method: "PUT",
    url: `/v1/organization/${organizationId}/profile`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateOrganizationProfileMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateOrganizationProfileMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateOrganizationProfileMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateOrganizationProfileMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: UpdateOrganizationProfilePathParams["organizationId"]
      data: UpdateOrganizationProfileMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ organizationId, data }) => {
      return updateOrganizationProfile(organizationId, data, config)
    },
  })
}

/**
 * @description Supplier portal users only. Updates name, address, registration IDs, and business type for the caller's organization.
 * @summary Update organization profile
 * {@link /v1/organization/:organizationId/profile}
 */
export function useUpdateOrganizationProfile<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateOrganizationProfileMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        organizationId: UpdateOrganizationProfilePathParams["organizationId"]
        data: UpdateOrganizationProfileMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateOrganizationProfileMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateOrganizationProfileMutationKey()

  const baseOptions = updateOrganizationProfileMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateOrganizationProfileMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: UpdateOrganizationProfilePathParams["organizationId"]
      data: UpdateOrganizationProfileMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateOrganizationProfileMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: UpdateOrganizationProfilePathParams["organizationId"]
      data: UpdateOrganizationProfileMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateOrganizationProfileMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: UpdateOrganizationProfilePathParams["organizationId"]
      data: UpdateOrganizationProfileMutationRequest
    },
    TContext
  >
}
